import { formatPercent } from 'features/usage/utils/usage-format';

export type UsageShareItem = {
  key: string;
  label: string;
  value: string;
  share: number;
};

/** Labelled bars; the largest item fills the track so small lists stay readable. */
export function UsageShareList({ items }: { items: UsageShareItem[] }) {
  const maxShare = Math.max(0, ...items.map((item) => item.share));

  return (
    <div className="space-y-3">
      {items.map((item) => (
        <div key={item.key} className="space-y-1.5">
          <div className="flex items-baseline justify-between gap-3 text-sm">
            <span className="min-w-0 truncate text-foreground">{item.label}</span>
            <span className="shrink-0 text-foreground">
              {item.value} <span className="text-muted-foreground">· {formatPercent(item.share)}</span>
            </span>
          </div>
          <div className="h-1.5 overflow-hidden rounded-full bg-muted">
            {item.share > 0 && (
              <div
                className="h-full min-w-1.5 rounded-full bg-foreground"
                style={{ width: `${(item.share / maxShare) * 100}%` }}
              />
            )}
          </div>
        </div>
      ))}
    </div>
  );
}
